// extracted by mini-css-extract-plugin
export default {"loaderSpinner":"spinner_loaderSpinner__i+r1b","rotation":"spinner_rotation__BFzGL"};